import React, { useState, useEffect } from "react";
import Footer from "../components/Footer";

const GalleryPage: React.FC = () => {
  const [selectedView, setSelectedView] = useState<string>("pictures");
  const [activeTab, setActiveTab] = useState<string>("first");

  useEffect(() => {
    // Load Fancybox script
    const script = document.createElement("script");
    script.src =
      "https://cdn.jsdelivr.net/gh/fancyapps/fancybox@3.5.7/dist/jquery.fancybox.min.js";
    script.async = true;
    document.head.appendChild(script);

    // Load Fancybox CSS
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href =
      "https://cdn.jsdelivr.net/gh/fancyapps/fancybox@3.5.7/dist/jquery.fancybox.min.css";
    document.head.appendChild(link);

    return () => {
      const existingScript = document.querySelector(
        `script[src="${script.src}"]`,
      );
      const existingLink = document.querySelector(`link[href="${link.href}"]`);
      if (existingScript && document.head.contains(existingScript)) {
        document.head.removeChild(existingScript);
      }
      if (existingLink && document.head.contains(existingLink)) {
        document.head.removeChild(existingLink);
      }
    };
  }, []);

  const showGallery = (view: string) => {
    setSelectedView(view);
  };

  const showStyle = (style: string) => {
    setActiveTab(style);
  };

  // Gallery images
  const galleryImages = [
    "cs1.JPG",
    "stemcafe1.jpg",
    "stemcafe2.jpg",
    "cs2.JPG",
    "stemcafe3.jpg",
    "stemcafe4.jpg",
    "stemcafe5.jpg",
    "cs3.JPG",
    "stemcafe6.jpg",
    "stemcafe7.jpg",
    "cs4.JPG",
    "stemcafe8.jpg",
    "stemcafe9.jpg",
    "stemcafe10.jpg",
    "cs5.JPG",
    "cs6.JPG",
    "stemcafe11.jpg",
    "stemcafe12.jpg",
    "stemcafe13.jpg",
    "cs7.JPG",
    "stemcafe21.jpg",
    "stemcafe22.jpg",
    "cs9.JPG",
    "cs10.JPG",
    "stemcafe24.jpg",
    "cs13.JPG",
    "stemcafe15.jpg",
    "stemcafe26.jpg",
    "cs11.JPG",
    "cs12.JPG",
    "stemcafe27.jpg",
    "cs8.JPG",
    "stemcafe29.jpg",
    "stemcafe30.jpg",
    "stemcafe31.jpg",
    "stemcafe32.jpg",
    "stemcafe33.jpg",
    "stemcafe34.jpg",
  ];

  const bigImages = ["stemcafe4.jpg", "cs4.JPG", "cs5.JPG", "stemcafe29.jpg"];

  return (
    <div>
      <div id="gallery" className="p60">
        <div className="container">
          <div className="page-header">
            <h2>Gallery</h2>
            <p>
              We have captured a lot of learning moments! See some of the
              amazing stuff built by kids at STEMCafe
            </p>

            <div className="links">
              <button
                onClick={() => {
                  showGallery("pictures");
                  showStyle("first");
                }}
                id="first"
                className={activeTab === "first" ? "first" : "unactive"}
              >
                Pictures
              </button>
              <button
                onClick={() => {
                  showGallery("videos");
                  showStyle("second");
                }}
                id="second"
                className={activeTab === "second" ? "second" : "unactive"}
              >
                Videos
              </button>
            </div>
          </div>

          {/* Pictures Gallery */}
          {selectedView === "pictures" && (
            <div className="gallery-grid" id="pictures">
              {galleryImages.map((image, index) => {
                const isBig = bigImages.includes(image);
                const imageUrl = require(`../assets/images/gallery/${image}`);

                return (
                  <div key={index} className={isBig ? "big" : ""}>
                    {image === "stemcafe9.jpg" ? (
                      <div>
                        <img src={imageUrl} alt="" />
                      </div>
                    ) : (
                      <a data-fancybox="gallery" href={imageUrl}>
                        <img src={imageUrl} alt="" />
                      </a>
                    )}
                  </div>
                );
              })}
            </div>
          )}

          {/* Videos Gallery */}
          {selectedView === "videos" && (
            <div id="videos">
              <div className="row">
                <div className="col-sm-4">
                  <div className="video">
                    <div className="image">
                      <iframe
                        src="https://www.youtube.com/embed/z5S7dq6i-Yo"
                        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="Tissue Paper Roll Car"
                      ></iframe>
                    </div>
                    <p>26 Nov 2019</p>
                    <h3>Tissue Paper Roll Car</h3>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="video">
                    <div className="image">
                      <iframe
                        src="https://www.youtube.com/embed/OQtAf7683OM"
                        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="Walking Water Experiment"
                      ></iframe>
                    </div>
                    <p>6 Aug 2019</p>
                    <h3>Walking Water Experiment</h3>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="video">
                    <div className="image">
                      <iframe
                        src="https://www.youtube.com/embed/zUAGiyREw4Y"
                        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="Water fireworks"
                      ></iframe>
                    </div>
                    <p>13 Aug 2019</p>
                    <h3>Water fireworks</h3>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default GalleryPage;
